module.exports = __webpack_public_path__ + "img/scanCreation.dee18b86.svg";